import { render } from "./pos-payment.vue?vue&type=template&id=35461ea9"
import script from "./pos-payment.vue?vue&type=script&lang=js"
export * from "./pos-payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__